import { Box, Tab, Tabs } from '@mui/material';
import { maxPageWidth } from './Page';

type TabsProps<T extends string> = {
  options: Array<{ label: string, value: T }>
  value: T
  onChange: (v: T) => void
  fullTabWidths?: boolean
};

export type TabsUIType = <T extends string>(args: TabsProps<T>) => React.ReactElement;
export const TabsUI: TabsUIType = ({ options, value, onChange, fullTabWidths }) => {
  const widthPerTab = fullTabWidths ? 100 / options.length : undefined;
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', maxWidth: maxPageWidth }}>
      <Tabs textColor="secondary" indicatorColor="secondary" variant="scrollable" scrollButtons="auto" value={value} onChange={(_, v) => onChange(v)}>
        {options.map(({ label, value }, i) => <Tab sx={{ width: `${widthPerTab}%` }} key={i} label={label} value={value} />)}
      </Tabs>
    </Box>
  );
};
